import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig } from '@spartacus/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { provideDefaultConfig } from '../../../../core/config';
import { I18nModule } from '../../../../core/i18n';
import { AlertMessageModule } from '../../../../shared/components/alert-message';
import { ServiceUnavailableAlertComponent } from './service-unavailable-alert.component';

@NgModule({
  imports: [CommonModule, I18nModule, NzIconModule, AlertMessageModule],
  declarations: [ServiceUnavailableAlertComponent],
  exports: [ServiceUnavailableAlertComponent],
  providers: [
    provideDefaultConfig(<CmsConfig>{
      cmsComponents: {
        ServiceUnavailableAlertComponent: {
          component: ServiceUnavailableAlertComponent,
        },
      },
    }),
  ],
})
export class ServiceUnavailableAlertModule {}
